import { FIELD_IS_VALID } from '../../../Constants';

const managingPersonValidation = (_persons, collection) => {
  const hasManagingPerson = Array.isArray(collection?.persons) && collection.persons.some(
    person => typeof person === 'string' && person.trim().length > 0
  ) || Array.isArray(collection?.creators) && collection.creators.some(
    creator => typeof creator === 'string'
      ? creator.trim().length > 0
      : typeof creator?.userName === 'string' && creator.userName.trim().length > 0
  );
  const hasManagingGroup = Array.isArray(collection?.iamgroups) && collection.iamgroups.some(
    group => typeof group === 'string' && group.trim().length > 0
  );

  if (!hasManagingPerson && !hasManagingGroup) {
    return 'collection_validation_managing_person_is_required';
  }

  return FIELD_IS_VALID;
};

export default managingPersonValidation;